import * as globals from "../globals";

export const getImagePath = (subscription_id, project_id, filename) => {
    if (!filename) return null;
    return `${globals.tempImageRoot}${subscription_id}/${project_id}/${filename}`;
}

